/* eslint-disable @next/next/no-img-element */
import { formatNumber } from '@/src/components/main-dashboard/utils'
import { useStore } from '@/src/types/store'
import { useEffect, useState } from 'react'
import SocialPostMedia from '@/src/components/SocialPostMedia'

export interface DataType {
  label: string
  value: string
  prev_val?: string
  header?: boolean
  key: string
}

export interface GraphInput {
  time: string
  value: number
}

export const staticIressCategory = ['Annual report', 'Half Year Reports', 'Quarterly Reports']

export const LOOK_UP_DUMMY_DATA = (data: DataType | any, newTheme: boolean) => {
  return [
    {
      label: 'Current price',
      value: data?.current_price ? `$${data?.current_price.toFixed(3)}` : '$0',
      prev_val: '$0.01 / 2.01%',
      header: true,
      key: 'current_price'
    },
    {
      label: 'Market cap',
      value: data?.market_cap ? `$${formatNumber(data?.market_cap, newTheme)}` : '0',
      key: 'market_cap'
    },
    {
      label: 'Open price',
      value: formatNumber(data?.open_price)?.toString() ?? '_',
      key: 'open_price'
    },
    {
      label: 'High',
      value: formatNumber(data?.high)?.toString() ?? '_',
      key: 'high'
    },
    {
      label: 'Low',
      value: formatNumber(data?.low)?.toString() ?? '_',
      key: 'low'
    },
    {
      label: 'Previous close',
      value: formatNumber(data?.previous_close)?.toString() ?? '_',
      key: 'previous_close'
    },
    {
      label: 'Shares on Issue',
      value: data?.shares_on_issue ? formatNumber(data?.shares_on_issue, newTheme) : '0',
      key: 'shares_on_issue'
    },
    {
      label: 'VWAP',
      value: data?.vwap ? `$${formatNumber(data?.vwap, newTheme)}` : '0',
      key: 'vwap'
    }
  ]
}

export const RandomImage = () => {
  const { homeTheme, companyThumbnails } = useStore()
  const [randomIndex, setRandomIndex] = useState<number | null>(null)

  useEffect(() => {
    if (companyThumbnails?.length > 0) {
      const index = Math.floor(Math.random() * companyThumbnails.length)
      setRandomIndex(index)
    }
  }, [companyThumbnails])
  return (
    <SocialPostMedia
      type="image"
      url={randomIndex !== null ? companyThumbnails[randomIndex]?.url : homeTheme?.banner}
      alt="Company thumbnail"
    />
  )
}
